import { useParkingaboServerWrite } from '../api/ParkingaboApi';

export function useRequestEmailChange() {
    return useParkingaboServerWrite<{ email: string | null }, void>(
        () => ({
            url: 'user/self/request-email-change',
        }),
        true,
    );
}
